export default __webpack_public_path__ + "images/oficinaDefatult.95029b0dfc45801a65936d58a6d25606.jpg";